(function () {
  var OS = window.OS || (window.OS = {});
  var root = OS.root || '/';
  if (root.slice(-1) !== '/') root += '/';
  OS.root = root;

  function sep(n, dec, ts, ds) {
    var parts = n.toFixed(dec).split('.');
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (parts[1] ? ds + parts[1] : '');
  }

  OS.formatMoney = function (cents) {
    var n = (+cents || 0) / 100;
    var format = OS.moneyFormat || '€{{amount_with_comma_separator}}';
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      var map = {
        amount: sep(n, 2, ',', '.'),
        amount_no_decimals: sep(n, 0, ',', '.'),
        amount_with_comma_separator: sep(n, 2, '.', ','),
        amount_no_decimals_with_comma_separator: sep(n, 0, '.', ','),
        amount_with_apostrophe_separator: sep(n, 2, "'", '.'),
        amount_with_space_separator: sep(n, 2, ' ', ',')
      };
      return map[key] || map.amount_with_comma_separator;
    });
  };

  OS.setCartCount = function (count) {
    document.querySelectorAll('.os-hd__cart').forEach(function (a) {
      var badge = a.querySelector('.os-hd__count');
      if (!count) { if (badge) badge.remove(); return; }
      if (!badge) { badge = document.createElement('span'); badge.className = 'os-hd__count'; a.appendChild(badge); }
      badge.textContent = count;
    });
  };

  document.addEventListener('cart:updated', function (e) {
    if (e.detail && typeof e.detail.item_count === 'number') OS.setCartCount(e.detail.item_count);
  });
})();
